import { CheckboxGroup, Loading, TextSpan } from "@dgs/core";
import { useField } from "formik";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { OrganizerOptionResource } from "../../types/organizer";
import { OrganizerMultiSelectField } from "../../ui/OrganizerMultiSelectField";
import { FilterAccordionBody, FilterAccordionItem, FilterCheckbox } from "./AccordionFilterItemStyles";
import { useEventFilterAccordionItems } from "./EventFilterAccordionItemsProvider";

interface Props {
	name: string;
}

export const AccordionItemOrganizer: FC<Props> = ({ name }) => {
	const { t } = useTranslation();
	const [{ value }, , { setValue }] = useField<OrganizerOptionResource[]>(name);
	const { organizers, organizersIsLoading, renderOrganizersAsCheckboxes } = useEventFilterAccordionItems();

	if (!organizers || !organizers.length) {
		return null;
	}

	const renderBody = () => {
		if (organizersIsLoading) return <Loading />;
		if (renderOrganizersAsCheckboxes) {
			return (
				<CheckboxGroup name={name}>
					{organizers.map((organizer) => (
						<FilterCheckbox
							key={`${organizer.id}`}
							name={`organizer-${organizer.id}`}
							value={value.some((v) => v.id === organizer.id)}
							label={organizer.name}
							onChange={(e) =>
								setValue(e.target.value ? [...value, organizer] : value.filter((v) => v.id !== organizer.id))
							}
						/>
					))}
				</CheckboxGroup>
			);
		}
		return <OrganizerMultiSelectField name={name} label="" />;
	};

	return (
		<FilterAccordionItem
			title={t("Organizer")}
			actions={<TextSpan $size="small">{t("IN_RELATION")}</TextSpan>}
			initialOpen={value && value.length > 0}
			body={<FilterAccordionBody>{renderBody()}</FilterAccordionBody>}
		/>
	);
};
